<adaa-data-table
    #usersTable
    titleHeader="breadcrumbs.users"
    apiName="getUsersList"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.USERS"
    [customActionButtons]="customButtons()"
    [disableDeleteRules]="disableDeleteRules()"
    [itemTypeId]="Constants.CONSTANT_PERMISSIONS.USERS"
    (actionClicked)="actionClicked($event)"
    (addNewClicked)="addNewClicked()"
/>
